import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "Projects", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex mb-2 justify-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Sync projects", -1)
const _hoisted_9 = { class: "mb-8 min-w-full border overflow-x-auto border-b border-indigo-100 rounded-md" }
const _hoisted_10 = { class: "table-auto min-w-full divide-y divide-indigo-100" }
const _hoisted_11 = { class: "bg-indigo-50" }
const _hoisted_12 = {
  colspan: "2",
  class: "px-4 py-3 text-left font-medium text-gray-800"
}
const _hoisted_13 = { class: "flex align-middle items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm md:text-base" }, "ABRA Sync status", -1)
const _hoisted_15 = { class: "mx-2 text-xs font-semibold text-center p-1 rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_16 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_17 = { class: "w-auto md:w-52 px-4 py-3 whitespace-nowrap" }
const _hoisted_18 = { class: "text-xs md:text-sm lg:text-base" }
const _hoisted_19 = { class: "mb-4 flex justify-between flex-col sm:flex-row" }
const _hoisted_20 = { class: "flex rounded-md mb-2 sm:mb-0 mr-0 sm:mr-2 md:mr-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Month ", -1)
const _hoisted_22 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshIcon = _resolveComponent("RefreshIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_project_list = _resolveComponent("project-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.syncReportLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_app_button, {
                      onClick: _ctx.syncProjects,
                      type: _ctx.syncButtonType,
                      class: _normalizeClass(['w-full sm:w-auto'])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_RefreshIcon, {
                          class: _normalizeClass(["h-5 w-5 mr-2 -ml-1", _ctx.syncButtonIconClass])
                        }, null, 8, ["class"]),
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick", "type"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                      _createElementVNode("thead", _hoisted_11, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _hoisted_14,
                              _createElementVNode("span", _hoisted_15, " Last sync: " + _toDisplayString(_ctx.formatDatetime(_ctx.syncReport.timeUpdated)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.syncReport.value), (message) => {
                          return (_openBlock(), _createElementBlock("tr", { key: message }, [
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(message), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                  class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: month.key,
                      value: month
                    }, _toDisplayString(month.name), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedMonth]
                ])
              ])
            ]),
            (_ctx.selectedMonth != null)
              ? (_openBlock(), _createBlock(_component_project_list, {
                  user: _ctx.user,
                  month: _ctx.selectedMonth,
                  key: _ctx.selectedMonth.key
                }, null, 8, ["user", "month"]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}